<template>
  <a-badge
    :count="useCount.count"
    :number-style="{
      top: '-5px'
    }"
    class="mr10 "
  >
    <CloudDownloadOutlined @click="showDrawer" style="font-size:18px;" />
  </a-badge>
  <a-drawer
    title="下载中心"
    class="small"
    placement="right"
    v-model:open="visible"
    width="40%"
    @close="closeDrawer"
  >
    <a-table
      size="small"
      rowKey="id"
      :dataSource="dataList"
      :columns="columns"
      bordered
      class="mb20"
      :scroll="{
        x: '100%',
        y: scrollY
      }"
      :pagination="pagination"
      @change="handleTableChange"
      ref="tableRef"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'deal'">
          <a
            :aria-disabled="!!downloadingIds[record.id]"
            @click="download(record)"
            v-if="record.exportFlag === 2"
            id="PRO-568c344a-dae3-4195-aa6c-cfe2f5a24186"
            >{{ downloadingIds[record.id] ? '下载中...' : '下载' }}</a
          >
          <p v-else>{{ record.exportFlagStr }}</p>
        </template>
      </template>
    </a-table>
  </a-drawer>
</template>
<script>
import { useStore } from 'vuex'
import { CloudDownloadOutlined } from '@ant-design/icons-vue'
import { reactive, toRefs, inject, computed, watch } from 'vue'
import { export_list_get, export_download_post } from 'server/modules/351.js'
import { message } from 'ant-design-vue'
import { downloadExportFile } from '@/utils/downloadExportFile'
import { handleLoginExpired } from '@/utils/loginExpired'
export default {
  components: {
    CloudDownloadOutlined
  },
  setup() {
    const store = useStore()
    const useCount = inject('useCount')
    const state = reactive({
      dataList: [],
      isLoading: false,
      downloadingIds: {},
      pagination: {
        total: 0,
        current: 1,
        pageSize: 20
      },

      // 监听菜单 触发埋点
      gaApi: item => {
        const { id, menuName } = item
        const { userName, userId } = store.state.user.userInfo
        // cupshe_GA(
        //   'click',
        //   {
        //     shop_id: '101',
        //     log_type: '2',
        //     event_category: 'click',
        //     event_name: 'btn_click',
        //     referer: window.history.state.back
        //   },
        //   {
        //     btn_id: 'PRO-' + id,
        //     btn_name: menuName + '',
        //     menu_name: menuName + '',
        //     menu_id: id + '',
        //     system_code: 'PRO',
        //     system_name: 'Portal统一登录系统',
        //     uname: userName,
        //     uid: userId,
        //     time: new Date()
        //   }
        // )
      },
      showDrawer: () => {
        store.commit('OPEN_DOWNLOAD_MODAL', true)
      },
      queryList: async () => {
        const {
          pagination: { pageSize, current }
        } = state
        const { success, data } = await export_list_get({
          pageSize,
          pageNum: current
        })
        if (success) {
          state.dataList = data.list
          state.pagination.total = data.total
        }
      },
      handleTableChange: pagination => {
        state.pagination = pagination
        state.queryList()
      },
      isImageType(file) {
        //用文件名name后缀判断文件类型，可用size属性判断文件大小不能超过500k ， 前端直接判断的好处，免去服务器的压力。
        if (!/\.(jpg|jpeg|png|GIF|JPG|PNG)$/.test(file)) {
          return false
        } else {
          return true
        }
      },
      // 下载
      download: async text => {
        if (state.downloadingIds[text.id]) return
        state.gaApi({
          btn_name: '下载任务',
          btn_id: 'PRO-568c344a-dae3-4195-aa6c-cfe2f5a24186'
        })
        const { id, fileName } = text
        state.downloadingIds[id] = true
        try {
          const { success, data } = await export_download_post({ id })
          if (!success) {
            message.error('服务器异常 ')
            return
          }
          await downloadExportFile({
            url: data,
            filename: fileName || String(Date.now()),
            adminBase: process.env.VUE_APP_ADMIN_API_BASE,
            getToken: () => localStorage.getItem('token'),
            legacyDownload: state.legacyDownload,
            onLoginExpired: handleLoginExpired
          })
        } catch (error) {
          if (error.code !== 'AUTH_EXPIRED') {
            message.error(error.message || '文件下载失败，请重试')
          }
        } finally {
          delete state.downloadingIds[id]
        }
      },
      legacyDownload(url, fileName) {
        if (state.isImageType(url)) {
          return new Promise((resolve, reject) => {
            const img = new Image()
            img.setAttribute('crossOrigin', 'anonymous')
            img.onload = () => {
              try {
                // 图片转base64地址
                let canvas = document.createElement('canvas')
                let context = canvas.getContext('2d')
                canvas.width = img.width
                canvas.height = img.height
                context.drawImage(img, 0, 0, img.width, img.height)

                state.triggerDownload(canvas.toDataURL(), fileName)
                resolve()
              } catch (error) {
                reject(error)
              }
            }
            img.onerror = () => reject(new Error('图片下载失败，请重试'))
            img.src = url
          })
        } else {
          state.triggerDownload(url, fileName)
        }
      },
      triggerDownload(url, fileName) {
        const archor = document.createElement('a')
        archor.setAttribute('href', url)
        archor.setAttribute('download', fileName || new Date().getTime()) //指示浏览器下载url,而
        document.body.appendChild(archor)
        archor.click()
        document.body.removeChild(archor)
      },
      columns: [
        {
          title: '文件名称',
          dataIndex: 'fileName',
          key: 'fileName',
          width: '30%'
        },
        {
          title: '导出时间',
          dataIndex: 'addTime',
          key: 'addTime',
          width: '35%'
        },

        {
          title: '操作',
          key: 'deal',
          width: '25%'
        }
      ]
    })
    const scrollY = computed(() => {
      const mql = window.matchMedia('(max-width: 1400px)')
      if (mql.matches) {
        return 590
      }
      return 770
    })
    const visible = computed(() => {
      return store.state.downLoadList.visible
    })
    const closeDrawer = () => {
      store.commit('OPEN_DOWNLOAD_MODAL', false)
    }
    watch(
      () => visible.value,
      val => {
        if (val) {
          useCount.count = 0
          if (localStorage.getItem('token')) {
            const { queryList } = state
            queryList()
          }
        }
      }
    )

    return {
      scrollY,
      useCount,
      ...toRefs(state),
      visible,
      closeDrawer
    }
  }
}
</script>
<style lang="scss">
.ant-badge-count {
  transform: scale(0.8) translate(50%, -50%) !important;
}
</style>
